export const makeGeneralStats = (generalStats: {
  total: number,
  totalClosed: number,
  totalOpenned: number,
  totalTaxAttendance: number,
  totalTaxCover: number
}) => ([
  {
    code: 'faturamento-total',
    title: 'Faturamento total',
    description: 'Somatória dos valores referentes a mesas fechadas, taxa de couver e atendimento',
    iconName: 'finance-filled',
    value: generalStats.total,
  },
  {
    code: 'mesas-aberto',
    title: 'Mesas em aberto',
    description: '',
    iconName: 'table-filled',
    value: generalStats.totalOpenned,
  },
  {
    code: 'mesas-fechadas',
    title: 'Mesas fechadas',
    description: '',
    iconName: 'table-filled',
    value: generalStats.totalClosed,
  },
  {
    title: 'Taxa cover',
    description: '',
    iconName: 'song-filled',
    value: generalStats.totalTaxCover,
  },
  {
    title: 'Taxa de atendimento',
    description: '',
    iconName: 'user-filled',
    value: generalStats.totalTaxAttendance,
  },
])

export const presetPeriods = [
  {
    id: 'today',
    label: 'Hoje',
  },
  {
    id: 'week',
    label: 'Semana',
  },
  {
    id: 'month',
    label: 'Mês',
  },
]
